import { nextArrow, prevArrow, options } from "@/global/slick-options";
import { get, getAll } from "@/utilities/querySelector";


const galleries = getAll( 'section.gallery' );

galleries.forEach( gallery => {
  const noNav = get( '.no-nav', gallery );
  const withNav = get( '.with-nav', gallery );
  const nav = get( '.nav', gallery );

  if ( noNav ) {
    jQuery( noNav ).slickLightbox( {
      src: 'href',
      itemSelector: '.image-slide a',
      slick: {
        prevArrow,
        nextArrow,
      }
    } );
  }

  if ( withNav && nav ) {

    jQuery( withNav ).slick( {
      ...options,
      infinite: true,
      slidesToShow: 1,
      arrows: false,
      asNavFor: nav
    } );

    jQuery( nav ).slick( {
      ...options,
      infinite: true,
      centerMode: true,
      centerPadding: '0',
      focusOnSelect: true,
      asNavFor: withNav,
      slidesToShow: 7,
      respondTo: 'slider',
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 5,
            centerMode: true,

          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 3,
            centerMode: true,

          }
        },
      ]
    } );

    jQuery( '.gallery-slider.with-nav' ).slickLightbox( {
      src: 'href',
      itemSelector: '.image-slide a',
      slick: {
        prevArrow,
        nextArrow,
      }
    } );
  }
} );
